export default "__VITE_ASSET__977d950c__"